"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Splice = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
const ResourceType_1 = require("../../ResourceType");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Resources_1 = require("../../Resources");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class Splice extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.SPLICE,
            tags: [Tags_1.Tags.MICROBE],
            startingMegaCredits: 48,
            initialActionText: 'Draw a card with a microbe tag',
            metadata: {
                cardNumber: 'R28',
                description: 'You start with 44 M€. As your first action, reveal cards until you have revealed a microbe tag. Take it and discard the rest.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(44).nbsp().cards(1).secondaryTag(Tags_1.Tags.MICROBE);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect(undefined, (eb) => {
                            eb.microbes(1).played.any.startEffect;
                            eb.megacredits(2).any.or().microbes(1).any.asterix();
                        });
                        ce.vSpace();
                        ce.effect('when a microbe tag is played, incl. this, THAT PLAYER gains 2 M€, or adds a microbe to THAT card, and you gain 2 M€.', (eb) => {
                            eb.microbes(1).played.any.startEffect;
                            eb.megacredits(2);
                        });
                    });
                }),
            },
        });
    }
    initialAction(player) {
        player.drawCard(1, { tag: Tags_1.Tags.MICROBE });
        return undefined;
    }
    onCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    onCorpCardPlayed(player, card) {
        return this._onCardPlayed(player, card);
    }
    _onCardPlayed(player, card) {
        if (card.tags.includes(Tags_1.Tags.MICROBE) === false) {
            return undefined;
        }
        const game = player.game;
        const gainPerMicrobe = 2;
        const microbeTagsCount = card.tags.filter((tag) => tag === Tags_1.Tags.MICROBE).length;
        const megacreditsGain = microbeTagsCount * gainPerMicrobe;
        const addResource = new SelectOption_1.SelectOption('Add a microbe resource to this card', 'Add microbe', () => {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                player.addResourceTo(card, { log: true });
                return undefined;
            }), DeferredAction_1.Priority.GAIN_RESOURCE_OR_PRODUCTION);
            return undefined;
        });
        const getMegacredits = new SelectOption_1.SelectOption(`Gain ${megacreditsGain} M€`, 'Gain M€', () => {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                player.addResource(Resources_1.Resources.MEGACREDITS, megacreditsGain, { log: true });
                return undefined;
            }), DeferredAction_1.Priority.GAIN_RESOURCE_OR_PRODUCTION);
            return undefined;
        });
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            const spliceOwner = game.getCardPlayer(this.name);
            spliceOwner.addResource(Resources_1.Resources.MEGACREDITS, megacreditsGain, { log: true });
            return undefined;
        }), DeferredAction_1.Priority.GAIN_RESOURCE_OR_PRODUCTION);
        if (card.resourceType !== undefined && card.resourceType === ResourceType_1.ResourceType.MICROBE) {
            return new OrOptions_1.OrOptions(addResource, getMegacredits);
        }
        else {
            game.defer(new DeferredAction_1.DeferredAction(player, () => {
                player.addResource(Resources_1.Resources.MEGACREDITS, megacreditsGain, { log: true });
                return undefined;
            }), DeferredAction_1.Priority.GAIN_RESOURCE_OR_PRODUCTION);
            return undefined;
        }
    }
    play() {
        return undefined;
    }
}
exports.Splice = Splice;
//# sourceMappingURL=Splice.js.map